import styles from './index.module.scss'
import { Stack, Typography } from '@mui/material'
import { memo, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { tabNames } from '../../../../routers/helpers'
import { useSelector } from 'react-redux'
import { selectActiveOrgId } from '../../../../redux/orgSlice'

const MySchoolTabs = () => {
    const location = useLocation()
    const value = location.pathname.split('/').at(-1) || 'overview'

    return (
        <Stack
            gap={3}
            flex={1}
            sx={{
                overflowY: 'auto',
            }}
        >
            {/* School Overview */}
            <Tab name={'overview'} value={value} />

            {/* Team */}
            <Tab name={'team'} value={value} />

            {/* Invoices */}
            <Tab name={'invoices'} value={value} />

            {/* Policies */}
            <Tab name={'policies'} value={value} />
        </Stack>
    )
}
type MySchoolTabKey = 'overview' | 'team' | 'invoices' | 'policies'
interface TabProps {
    title: string
    subtitle: string
    icon: ReactNode
    path: string
}
const tabMaps: Record<MySchoolTabKey, TabProps> = {
    overview: {
        title: 'School Overview',
        subtitle: 'What teachers see',
        // prettier-ignore
        icon: <svg width="40" height="40" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13.0889 30.3853C13.0889 31.8706 14.1009 32.85 15.6515 32.85H24.3677V40.5868C24.3677 42.8557 25.543 45.1898 26 45.1898C26.4407 45.1898 27.6159 42.8557 27.6159 40.5868V32.85H36.3485C37.8991 32.85 38.8948 31.8706 38.8948 30.3853C38.8948 26.8596 36.1037 23.2523 31.4844 21.5548L30.9621 13.9485C33.3941 12.5774 35.3202 11.0594 36.1526 9.96575C36.6097 9.39446 36.8218 8.79053 36.8218 8.26821C36.8218 7.19092 36.0057 6.39111 34.7652 6.39111H17.2185C15.9943 6.39111 15.1618 7.19092 15.1618 8.26821C15.1618 8.79053 15.374 9.39446 15.8311 9.96575C16.6635 11.0594 18.5896 12.5774 21.0216 13.9485L20.4993 21.5548C15.88 23.2523 13.0889 26.8596 13.0889 30.3853Z" fill="#F0F0F0"/> </svg>,
        path: 'overview',
    },
    team: {
        title: 'Team',
        subtitle: 'Manage staff who can access and manage this school',
        // prettier-ignore
        icon: <svg width="40" height="40" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M34.5366 25.2111C38.1112 25.2111 41.1309 22.0445 41.1309 17.9475C41.1309 13.9485 38.0949 10.8799 34.5366 10.8799C30.9946 10.8799 27.9422 13.9975 27.9586 17.9802C27.9586 22.0445 30.9619 25.2111 34.5366 25.2111ZM15.6677 25.5865C18.7853 25.5865 21.4132 22.8117 21.4132 19.2533C21.4132 15.7603 18.7527 13.0997 15.6677 13.0997C12.5827 13.0997 9.92215 15.8093 9.93848 19.286C9.93848 22.8117 12.5664 25.5865 15.6677 25.5865ZM6.67397 40.4074H18.9159C17.1694 37.91 19.0465 32.9806 22.7354 30.0752C20.9399 28.9163 18.6057 28.0675 15.6677 28.0675C8.37151 28.0675 3.6543 33.4376 3.6543 37.861C3.6543 39.477 4.47042 40.4074 6.67397 40.4074ZM24.3676 40.391H44.7055C47.3987 40.391 48.3291 39.5749 48.3291 38.0732C48.3291 33.8783 42.9916 28.1002 34.5366 28.1002C26.0651 28.1002 20.744 33.8783 20.744 38.0732C20.744 39.5749 21.6744 40.391 24.3676 40.391Z" fill="#F0F0F0"/> </svg>,
        path: 'team',
    },
    invoices: {
        title: 'Invoices',
        subtitle: 'Billing and payment history',
        // prettier-ignore
        icon: <svg width="40" height="40" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M25.9835 42.2355C35.2383 42.2355 42.8773 34.5965 42.8773 25.358C42.8773 16.1194 35.222 8.48047 25.9671 8.48047C16.7286 8.48047 9.10596 16.1194 9.10596 25.358C9.10596 34.5965 16.7449 42.2355 25.9835 42.2355ZM25.9671 34.8903C25.5264 34.8903 25.2 34.5639 25.2 34.1069V32.948C22.7679 32.7521 20.9724 31.4789 20.4828 29.6835C20.4175 29.4713 20.3848 29.2754 20.3848 29.0795C20.3848 28.394 20.8582 27.9206 21.5601 27.9206C22.1477 27.9206 22.5394 28.2307 22.7842 28.8347C23.0454 29.8304 23.8452 30.5649 25.2 30.7607V26.321L24.9062 26.2557C22.0824 25.6028 20.6134 24.297 20.6134 22.0935C20.6134 19.7104 22.5231 18.0781 25.2 17.8333V16.6907C25.2 16.2174 25.5264 15.9072 25.9671 15.9072C26.4079 15.9072 26.7506 16.2337 26.7506 16.6907V17.8333C29.0358 18.0618 30.7333 19.3186 31.1904 21.0652C31.2393 21.261 31.2883 21.4569 31.2883 21.6528C31.2883 22.3057 30.8149 22.779 30.1294 22.779C29.5255 22.779 29.1337 22.4362 28.8889 21.8813C28.5624 20.8856 27.8279 20.249 26.7506 20.0532V24.248L27.126 24.3297C30.0804 24.8846 31.5658 26.2394 31.5658 28.5572C31.5658 31.1362 29.5091 32.7194 26.7506 32.9643V34.1069C26.7506 34.5639 26.4079 34.8903 25.9671 34.8903ZM25.2 23.8563V20.0368C23.9105 20.249 23.127 21.0162 23.127 21.9302C23.127 22.8443 23.731 23.4319 25.0857 23.8237L25.2 23.8563ZM26.7506 26.6964V30.7607C28.3013 30.5812 29.0684 29.7977 29.0684 28.7367C29.0684 27.79 28.5298 27.1698 27.0608 26.778L26.7506 26.6964Z" fill="#F0F0F0"/> </svg>,
        path: 'invoices',
    },
    policies: {
        title: 'Policies',
        subtitle: "View and manage your school's policies here",
        // prettier-ignore
        icon: <svg width="40" height="40" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M39.3353 12.9855H24.2043C23.0291 12.9855 22.3272 12.7243 21.4132 11.9735L20.4991 11.2227C19.3402 10.2759 18.4914 9.96582 16.7776 9.96582H12.1583C9.08963 9.96582 7.27783 11.7613 7.27783 15.2054V19.7757H44.7054V18.3066C44.7054 14.8136 42.861 12.9855 39.3353 12.9855ZM12.6479 40.4237H39.7271C42.8773 40.4237 44.7054 38.5956 44.7054 35.1025V22.1261H7.27783V35.1025C7.27783 38.6119 9.12228 40.4237 12.6479 40.4237Z" fill="#F0F0F0"/> </svg>,
        path: 'policies',
    },
}

const Tab = ({ name, value }: { name: MySchoolTabKey; value: string }) => {
    const { icon, title, subtitle } = tabMaps[name]
    const navigate = useNavigate()
    const orgId = useSelector(selectActiveOrgId)

    return (
        <Stack
            role="button"
            className={`${styles.tab} ${value === name ? styles.selected : ''}`}
            onClick={() => {
                navigate(
                    `${tabNames.app.school.index}/${orgId}/my-school/${name}`
                )
            }}
        >
            {icon}
            <Stack flex={1}>
                <Typography fontWeight={600}>{title}</Typography>
                <Typography variant="ps">{subtitle}</Typography>
            </Stack>
        </Stack>
    )
}

export default memo(MySchoolTabs)
